import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { CompetitionService } from '../../service/CompetitionService';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import { DataTable } from 'primereact/datatable';
import DataTableUtils from '../../utilities/DataTableUtils';
import { Column } from 'primereact/column';

const CompetitionJobWrittenExamChangeHistoryDialog = (props) => {
    const [changesList, setChangesList] = useState([]);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        const getChanges = async () => {
            await competitionService.getCompetitionCalendarChange(props?.competition?.id)
                .then((_changeList) => {
                    // console.log("_changeList: ", _changeList);
                    setChangesList(_changeList);
                })
                .catch((error) => error && toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getChanges();
    }, [props, competitionService]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
    };

    const formDialogHeader = () => {
        return (<>
            <div>{translatedMessage('competition.writtenTest.postpone.history')}</div>
        </>)
    };

    const approvedTemplate = (_data) => {
        let _status = _data.approved === null ? 'pending' : (_data.approved ? 'approved' : 'rejected')
        return (<>
            <div>{translatedMessage('competition.exam.postpone.' + _status)}</div>
        </>)
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                header={formDialogHeader}
                modal
                onHide={hideDialog}
                className="pcn-dialog p-fluid"
                footer={formDialogFooter}
            >
                <DataTable
                    ref={dt}
                    value={changesList}
                    dataKey="id"
                    // paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    responsiveLayout="scroll"
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    // currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                    sortField='examDate'
                    sortOrder={-1}
                >
                    <Column
                        field="competitionCalendar.examType"
                        header={translatedMessage('competition.exam.name')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '10rem' }}
                        body={(e) => CompetitionUtils.getExamNameByType(e.competitionCalendar)}
                    />
                    <Column
                        field="oldExamDate"
                        header={translatedMessage('competition.calendar.exam.panned')}
                        sortable
                        headerStyle={{ width: '40%', minWidth: '10rem' }}
                        body={(e) => {
                            return (<>
                                <div className='mb-1'>
                                    <span className="font-bold">{translatedMessage('competition.exam.examDate') + ": "}</span>
                                    <span>{GeneralUtils.formatDateTime(e.oldExamDate)}</span>
                                </div>
                                <div>
                                    <span className="font-bold">{translatedMessage('competition.exam.examLocation') + ": "}</span>
                                    <span>{e.oldExamLocation}</span>
                                </div>
                            </>)
                        }}
                    />
                    <Column
                        field="examDate"
                        header={translatedMessage('competition.calendar.exam.posponed')}
                        sortable
                        headerStyle={{ width: '40%', minWidth: '10rem' }}
                        body={(e) => {
                            return (<>
                                <div className='mb-1'>
                                    <span className="font-bold">{translatedMessage('competition.exam.examDate') + ": "}</span>
                                    <span>{GeneralUtils.formatDateTime(e.examDate)}</span>
                                </div>
                                <div>
                                    <span className="font-bold">{translatedMessage('competition.exam.examLocation') + ": "}</span>
                                    <span>{e.examLocation}</span>
                                </div>
                            </>)
                        }}
                    />
                    <Column
                        field="approved"
                        header={translatedMessage('generic.status')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '10rem' }}
                        body={(e) => approvedTemplate(e)}
                    />
                </DataTable>

            </Dialog>
        </>
    );
};

export default CompetitionJobWrittenExamChangeHistoryDialog;